import { useFlag } from '@automata/utils/hooks';
import Stack from '@mui/material/Stack';
import {
  GridSortModel,
  GridToolbarContainer,
  GridToolbarFilterButton,
} from '@mui/x-data-grid-pro';

import { FilterByTagPopover } from 'components/FilterByTagPopover';
import { Column } from 'components/ModelList/types';

import SearchInput from './SearchInput';
import SortSelect from './SortSelect';
import { FilterWithDependencies } from '../../filtersManifest';

type SortFilter =
  | {
      sortableColumns: Column[];
      handleSortChange: (sortModel: GridSortModel) => void;
    }
  | undefined;

export interface Props {
  availableFilters: FilterWithDependencies[];
  disableSearch?: boolean;
  enableFilterByTag?: boolean;
  sortFilter?: SortFilter;
  defaultSort?: string;
  onOpenDatePanel?: () => void;
}

// required for slots/slotProps in ModelList config after datagrid v7.x
declare module '@mui/x-data-grid-pro' {
  interface ToolbarPropsOverrides extends Props {}
}

const Toolbar = ({
  availableFilters,
  disableSearch = false,
  enableFilterByTag = false,
  sortFilter,
  defaultSort,
  onOpenDatePanel, // <= новый проп
}: Props): JSX.Element => {
  const tagsEnabled = useFlag('fe.tags');

  const handleChange = (val: string) => {
    if (sortFilter) {
      sortFilter.handleSortChange([
        {
          field: val,
          sort: val === 'name' ? 'asc' : 'desc',
        },
      ]);
    }
  };

  const handleFiltersClick = () => onOpenDatePanel?.();

  return (
    <GridToolbarContainer
      sx={{
        display: 'flex',
        alignItems: 'flex-end',
        backgroundColor: 'grey.50',
        px: 0,
        py: 1,
        my: 2,
        borderRadius: 1,
        justifyContent: 'space-between',
      }}
    >
      <Stack direction="row" spacing={1}>
        {sortFilter && sortFilter.sortableColumns.length > 0 && (
          <SortSelect
            sortableColumns={sortFilter.sortableColumns}
            handleChange={handleChange}
            defaultValue={defaultSort}
          />
        )}

        {availableFilters.length > 0 && !sortFilter ? (
          <span onClick={handleFiltersClick} style={{ display: 'inline-flex' }}>
            <GridToolbarFilterButton />
          </span>
        ) : (
          <div />
        )}

        {tagsEnabled && enableFilterByTag && <FilterByTagPopover />}
      </Stack>

      {!disableSearch && (
        <SearchInput useCustomFilterModel={availableFilters.length > 0} />
      )}
    </GridToolbarContainer>
  );
};

export default Toolbar;
